import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.74087 16C5.84498 16 5.40111 14.9126 6.04109 14.2856L11.7579 8.6855C12.1467 8.30464 12.7687 8.30464 13.1575 8.6855L18.8743 14.2856C19.5143 14.9126 19.0704 16 18.1745 16L6.74087 16Z\" fill=\"#6300FA\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol